/**
 * Stacking order between canvas card types, kept in one neutral place so a card component never needs
 * to import another card component (e.g. Note depending on Reference) just to stay above or below it.
 */
/** Below the normal reference tier — a reference that anchors other elements shouldn't visually dominate them. */
export const REFERENCE_CARD_HOSTING_ANCHOR_Z_INDEX = 1;
export const REFERENCE_CARD_Z_INDEX = 2;
export const NOTE_CARD_Z_INDEX = 3;
